import { cn } from '$components'
import { ElementType, Fragment, ReactNode } from 'react'
import { NavLink } from 'react-router-dom'
import { Text } from '$components'

export type NavigationLinkProps = {
  to: string,
  children?: ReactNode,
  icon: ElementType,
  onClick?: () => void,
}

export function NavigationLink({ to, children, icon: Icon, onClick }: NavigationLinkProps) {

  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) => cn(
        'flex gap-stack-tight p-stack items-center rounded-card-sm',
        {
          'bg-fg text-fg-inverse': isActive,
          'hover:bg-bg-subtle text-fg': !isActive,
        },
      )}
    >
      {({ isActive }) => (
        <Fragment>
          <Icon className={cn(
            'size-[20px] min-w-[20px] min-h-[20px]',
            {
              'text-fg-inverse': isActive,
            },
          )}
          />

          <Text
            type="s"
            className={cn(
              'truncate',
              {
                'text-fg-inverse': isActive,
              },
            )}
          >
            { children }
          </Text>
        </Fragment>
      )}
    </NavLink>
  )
}
